import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import { ErrorBanner } from './ui/ErrorBanner';

/**
 * Catches a render crash in one page so the shell (nav, search) stays usable instead of the whole
 * app unmounting to a blank screen. Keyed by location in AppShell, so navigating away resets it.
 */
export class PageErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  override state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Page render failed', error, info.componentStack);
  }

  override render() {
    if (this.state.error) return <ErrorBanner title="This page could not be displayed" error={this.state.error} />;
    return this.props.children;
  }
}
